import gql from "graphql-tag";

export const GET_SELECTED_BACKLOG_ACTIVITY = gql`
  query ($activityId: ID!) {
    getSelectedBacklogActivity(activityId: $activityId) {
      _id
      title
      details
      isCompleted
      description
      assigned {
        full_name
        email
        avatar
      }
      created_by {
        full_name
        email
        avatar
      }
      tags
      planned_date
      key
      content
      timebox
      fileSources
      playbook {
        _id
        title
        description

        activities {
          _id
          title
          content
          fileSources
          isCompleted
          tags
          priority
          tasks {
            _id
            description
            planned
            completed
            assigned {
              _id
              full_name
              email
              avatar
            }
          }
          created_by {
            _id
            email
            full_name
            avatar
          }
        }
      }

      playbookReference {
        _id
        title
        key
        playbook {
          _id
          title
          activities {
            _id
            title
            isCompleted
            time {
              _id
              start
              end
              day_duration
              total_time
              paused {
                _id
                created_at
                time
                continue
                total
                timebox
              }
            }
            tasks {
              description
              completed
              assigned {
                full_name
                email
                _id
                avatar
              }
            }
          }
        }
      }

      tasks {
        _id
        description
        planned
        completed
        assigned {
          _id
          full_name
          email
          avatar
        }
      }
      commentCounts
      workspace {
        project {
          _id
          title
          color
          members {
            _id
            email
            avatar
            full_name
          }
          created_by {
            _id
            email
            avatar
            full_name
          }
          manager_id {
            _id
            email
            avatar
            full_name
          }
        }
      }
      created_at
      activity_persona {
        _id
        github {
          link
          status
          title
        }
        slackMessageURL
      }
    }
  }
`;
